import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchBooks } from "../../store/features/Book/actionCreator";
import BookItem from "./components/BookItem";

export default function BookWrapper() {
  const [featureFiltered, setIsfeatureFiltered] = useState(false);
  const [filteredBooks, setFilteredBooks] = useState([]);
  const dispatch = useDispatch();
  const { allBooks: books, error } = useSelector((state) => state.book);
  const search = useSelector((state) => state.search);

  function filterBooksBySearchQuery() {
    if (!search || error) {
      setFilteredBooks(books);
      return;
    }

    const filteredBooks = books.filter((book) => {
      const bookName = book.name.toLowerCase();
      return bookName.includes(search.toLowerCase());
    });

    setFilteredBooks(filteredBooks);
  }

  useEffect(() => {
    dispatch(fetchBooks(featureFiltered));
  }, [featureFiltered]);

  useEffect(() => {
    filterBooksBySearchQuery();
  }, [search, books, error]);

  return (
    <div className="order-2 xl:-order-1">
      <div className="flex items-center justify-between mb-12">
        <h4 className="mt-2 text-xl font-bold">Book List</h4>
        <div className="flex items-center space-x-4">
          <button
            onClick={() => setIsfeatureFiltered(false)}
            className={`filter-btn ${featureFiltered || "active-filter"}`}
            id="lws-filterAll"
          >
            All
          </button>
          <button
            onClick={() => setIsfeatureFiltered(true)}
            className={`filter-btn ${featureFiltered && "active-filter"}`}
            id="lws-filterFeatured"
          >
            Featured
          </button>
        </div>
      </div>
      <div className="lws-bookContainer">
        {/* Card 1 */}
        {error ? (
          <h1>{error}</h1>
        ) : books.length === 0 ? (
          <h1>No books found</h1>
        ) : (
          filteredBooks.map((book) => <BookItem key={book.id} book={book} />)
        )}
      </div>
    </div>
  );
}
